export default __webpack_public_path__ + "static/media/footer-instagram.d4085a17.svg";